import { PAGroupUtility } from "./pa-group.utility";
import { PAMenuMobile, PASection, PASector } from "./pa-menu-meta";
import { PABaseUtility } from "./pa-base.utility";

export class PASectionUtility extends PABaseUtility {

  public static buildSectionAccount(index: number): PASection {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildGrpAccount(counter++));
    return new PASection('account', 'LABEL_ACCOUNTS', index, PABaseUtility.filterGroups(groups));
  }

  public static buildSectionTransfers(index: number): PASection {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildGrpInternalTransfers(counter++));
    groups.push(PAGroupUtility.buildGrpExternalTransfers(counter++));
    return new PASection('transfers', 'LABEL_TRANSFERS', index, PABaseUtility.filterGroups(groups));
  }

  public static buildSectionInternalTransfers(index: number): PASection {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildGrpInternalTransfers(counter++));
    return new PASection('internalTransfer', 'LABEL_INTERNAL_TRANSFERS', index, PABaseUtility.filterGroups(groups));
  }

  public static buildSectionExternalTransfers(index: number): PASection {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildGrpExternalTransfers(counter++));
    return new PASection('externalTransfer', 'LABEL_EXTERNAL_TRANSFERS', index, PABaseUtility.filterGroups(groups));
  }
  
  public static buildSectionPayments(index: number): PASection {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildGrpPayments(counter++));
    return new PASection('payments', 'LABEL_PAYMENTS', index, PABaseUtility.filterGroups(groups));
  }

  public static buildSectionPayroll(index: number): PASection {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildGrpPayroll(counter++));
    return new PASection('payroll', 'PAYROLL', index, PABaseUtility.filterGroups(groups));
  }

  public static buildSectionOrders(index: number): PASection {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildGrpOrders(counter++));
    return new PASection('orders', 'ORDERS', index, PABaseUtility.filterGroups(groups));
  }

  public static buildSectionServices(index: number): PASection {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildGrpServices(counter++));
    return new PASection('services', 'LABEL_SERVICES', index, PABaseUtility.filterGroups(groups));
  }

  public static buildSectionSettings(index: number): PASection {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildGrpSettings(counter++));
    return new PASection('settings', 'LABEL_SETTINGS', index, PABaseUtility.filterGroups(groups));
  }

  public static buildSectionExternalLinks(index: number): PASection {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildGrpExternalLinks(counter++));
    return new PASection('externalLinks', 'LABEL_EXTERNAL_LINKS', index, PABaseUtility.filterGroups(groups));
  }

  public static buildSectionCorp(index: number): PASection {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildGrpCorp(counter++));
    return new PASection('corporate', 'LABEL_PAYMENTS', index, PABaseUtility.filterGroups(groups));
  }

  public static buildSector_A_Desktop(index: number): PASector {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildMobileGrpHome(counter++));
    groups.push(PAGroupUtility.buildMobileGrpInternalTransfers(counter++));
    groups.push(PAGroupUtility.buildMobileGrpExternalTransfers(counter++));
    groups.push(PAGroupUtility.buildMobileGrpPayments(counter++));
    groups.push(PAGroupUtility.buildMobileViewGrpQRCode(counter++));
    return new PASector(PAMenuMobile.SECTOR_A, index, PABaseUtility.filterMobileGroups(groups));
  }

  public static buildSector_B_Desktop(index: number): PASector {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildMobileGrpTopup(counter++));
    
    // groups.push(PAGroupUtility.buildMobileGrpQueue(counter++));

    groups.push(PAGroupUtility.buildMobileGrpOrders(counter++));
    groups.push(PAGroupUtility.buildMobileGrpServices(counter++));
    groups.push(PAGroupUtility.buildMobileGrpExternalLinks(counter++));
    return new PASector(PAMenuMobile.SECTOR_B, index, PABaseUtility.filterMobileGroups(groups));
  }

  public static buildSector_A_Mobile(index: number): PASector {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildMobileGrpHome(counter++));
    groups.push(PAGroupUtility.buildMobileGrpInternalTransfers(counter++));
    groups.push(PAGroupUtility.buildMobileGrpExternalTransfers(counter++));
    groups.push(PAGroupUtility.buildMobileGrpPayments(counter++));
    groups.push(PAGroupUtility.buildMobileGrpDeposits(counter++));
    groups.push(PAGroupUtility.buildMobileAppGrpQRCode(counter++));
    return new PASector(PAMenuMobile.SECTOR_A, index, PABaseUtility.filterMobileGroups(groups));
  }

  public static buildSector_B_Mobile(index: number): PASector {
    let counter = 0, groups = [];
    groups.push(PAGroupUtility.buildMobileGrpTopup(counter++));
    groups.push(PAGroupUtility.buildMobileGrpQueue(counter++));
    groups.push(PAGroupUtility.buildMobileGrpOrders(counter++));
    groups.push(PAGroupUtility.buildMobileGrpServices(counter++));
    groups.push(PAGroupUtility.buildMobileGrpExternalLinks(counter++));
    return new PASector(PAMenuMobile.SECTOR_B, index, PABaseUtility.filterMobileGroups(groups));
  }
}